import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form,  Errors, actions} from 'react-redux-form'
import {Row, Col} from 'react-bootstrap'
import LayoutContainer from "../../../layout/layout-container/index";
import ErrorMessages from '../../login/error-messages'
import UserTitleSelector from '../../../common/form/user/user-title-selector'
import UserFirstNameInput from '../../../common/form/user/user-first-name-input'
import UserLastNameInput from '../../../common/form/user/user-last-name-input'
import DateOfBirthSelector from '../../../common/form/user/date-of-birth-selector'
import ArrowButton from '../../../common/button-arrow'
import Can, {checkPermission} from "../../../common/guards/can";
import {savePpcUser} from '../../../../actions/ppc'
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredSelect from '../../../common/form/elements/required-select';

class UserDetailsForm extends Component {

  constructor(props) {
    super(props);
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_ppc.management.user', savePpcUser(this.props.id, payLoad)));
  };

  render() {
    return (
      <LayoutContainer>
        <Form model="deep.admin_ppc.management.user"
              className="user-details-form"
              onSubmit={this.onSubmit}>
          <Errors className="errors" model="deep.admin_ppc.management.user" component={ErrorMessages}/>
          <Row>
            <Col lg={6}>
              <UserTitleSelector/>

              <UserFirstNameInput/>

              <UserLastNameInput/>

              <DateOfBirthSelector/>

              <RequiredInput model=".email"
                             placeholder="email"
                             label="Email address"
                             readOnly/>

              <RequiredInput model=".mobile"
                             placeholder="mobile"
                             label="Mobile number"
                             readOnly/>
            </Col>

            <Col lg={6}>
              <RequiredInput model=".address_1"
                             placeholder="Address line 1"
                             label="Address line 1"
                             controlId="personal_address_1"/>

              <RequiredInput model=".address_2"
                             placeholder="Address line 2"
                             label="Address line 2"
                             controlId="personal_address_2"/>

              <RequiredInput model=".town"
                             placeholder="Town"
                             label="Town"
                             controlId="personal_address_3"/>

              <RequiredInput model=".county"
                             placeholder="County"
                             label="County"
                             controlId="personal_address_4"/>

              <RequiredInput model=".eircode"
                             placeholder="Eircode"
                             label="Eircode"
                             controlId="eircode"/>

              <RequiredSelect model=".kyc_status"
                              values={this.props.statuses}
                              hasEmptyValue={false}
                              controlId="kyc_status"
                              label="KYC status"/>
            </Col>

          </Row>
          <Row>
            <ArrowButton className="pull-right"
                         disabled={!this.props.formValid}>Save</ArrowButton>
          </Row>
        </Form>
      </LayoutContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    formValid:   state.deep.forms.admin_ppc.management.user.$form.valid,
  };
};

export default connect(mapStateToProps)(UserDetailsForm);


// WEBPACK FOOTER //
// ./src/components/admin/ppc/user/ppc-user-form.jsx